// proto/v2/budget/budget.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file budget/budget.proto (package lvdr.v2.budget, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file budget/budget.proto.
 */
export const file_budget_budget: GenFile = /*@__PURE__*/
  fileDesc("ChNidWRnZXQvYnVkZ2V0LnByb3RvEg5sdmRyLnYyLmJ1ZGdldCIZChdHZXRDcmVkaXRCYWxhbmNlUmVxdWVzdCJvChVDcmVkaXRCYWxhbmNlUmVzcG9uc2USDwoHYmFsYW5jZRgBIAEoARITCgt0b3RhbF9zcGVudBgCIAEoARIwCgxsYXN0X3VwZGF0ZWQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIksKGUNyZWRpdEJhbGFuY2VVcGRhdGVkRXZlbnQSDwoHYmFsYW5jZRgBIAEoARINCgVkZWx0YRgCIAEoARIOCgZyZWFzb24YAyABKAkiPAoWQ3JlZGl0c0xvd1dhcm5pbmdFdmVudBIPCgdiYWxhbmNlGAEgASgBEhEKCXRocmVzaG9sZBgCIAEoASKDAQoVQ3JlZGl0c0V4aGF1c3RlZEV2ZW50Eg8KB2JhbGFuY2UYASABKAESMAoMZXhoYXVzdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIWCg5lc3RpbWF0ZWRfY29zdBgDIAEoARIPCgdtZXNzYWdlGAQgASgJImgKFENyZWRpdHNSZWZpbGxlZEV2ZW50Eg8KB2JhbGFuY2UYASABKAESDgoGYW1vdW50GAIgASgBEi8KC3JlZmlsbGVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJhChdBdXRvUmVmaWxsQ2hlY2tvdXRFdmVudBIPCgdiYWxhbmNlGAEgASgBEhEKCXRocmVzaG9sZBgCIAEoARIUCgxjaGVja291dF91cmwYAyABKAkSDAoEcGFjaxgEIAEoCSJEChBUaWVyQ2hhbmdlZEV2ZW50Eg4KBm9yZ19pZBgBIAEoCRIQCghuZXdfdGllchgCIAEoCRIOCgZyZWFzb24YAyABKAkiQwoQU2VhdFJldm9rZWRFdmVudBIOCgZvcmdfaWQYASABKAkSDwoHdXNlcl9pZBgCIAEoCRIOCgZyZWFzb24YAyABKAkiKwoVR2V0Q2hhdENyZWRpdHNSZXF1ZXN0EhIKCnNlc3Npb25faWQYASABKAkiPQoWR2V0Q2hhdENyZWRpdHNSZXNwb25zZRISCgpzZXNzaW9uX2lkGAEgASgJEg8KB2NyZWRpdHMYAiABKAMiHAoaR2V0Q3JlZGl0c0JyZWFrZG93blJlcXVlc3QikAEKGENyZWRpdHNCcmVha2Rvd25SZXNwb25zZRIMCgRjaGF0GAEgASgDEg0KBXZvaWNlGAIgASgDEhAKCHJlc2VhcmNoGAMgASgDEg0KBW90aGVyGAQgASgDEhIKCnJlY29yZGluZ3MYBSABKAMSEQoJZG9jdW1lbnRzGAYgASgDEg8KB3N0b3JhZ2UYByABKAMiLAoWR2V0Vm9pY2VDcmVkaXRzUmVxdWVzdBISCgpzZXNzaW9uX2lkGAEgASgJIj4KF0dldFZvaWNlQ3JlZGl0c1Jlc3BvbnNlEhIKCnNlc3Npb25faWQYASABKAkSDwoHY3JlZGl0cxgCIAEoAyIeChxHZXRBdXRvUmVmaWxsU2V0dGluZ3NSZXF1ZXN0IlMKH1VwZGF0ZUF1dG9SZWZpbGxTZXR0aW5nc1JlcXVlc3QSDwoHZW5hYmxlZBgBIAEoCBIRCgl0aHJlc2hvbGQYAiABKAMSDAoEcGFjaxgDIAEoCSJOChpBdXRvUmVmaWxsU2V0dGluZ3NSZXNwb25zZRIPCgdlbmFibGVkGAEgASgIEhEKCXRocmVzaG9sZBgCIAEoAxIMCgRwYWNrGAMgASgJQidaJWdpdGh1Yi5jb20vZ3ZzNDIvbHZkci9wcm90by92Mi9idWRnZXRiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.budget.GetCreditBalanceRequest
 */
export type GetCreditBalanceRequest = Message<"lvdr.v2.budget.GetCreditBalanceRequest"> & {
};

/**
 * Describes the message lvdr.v2.budget.GetCreditBalanceRequest.
 * Use `create(GetCreditBalanceRequestSchema)` to create a new message.
 */
export const GetCreditBalanceRequestSchema: GenMessage<GetCreditBalanceRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 0);

/**
 * Responses
 *
 * @generated from message lvdr.v2.budget.CreditBalanceResponse
 */
export type CreditBalanceResponse = Message<"lvdr.v2.budget.CreditBalanceResponse"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: double total_spent = 2;
   */
  totalSpent: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated = 3;
   */
  lastUpdated?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.budget.CreditBalanceResponse.
 * Use `create(CreditBalanceResponseSchema)` to create a new message.
 */
export const CreditBalanceResponseSchema: GenMessage<CreditBalanceResponse> = /*@__PURE__*/
  messageDesc(file_budget_budget, 1);

/**
 * Events
 *
 * @generated from message lvdr.v2.budget.CreditBalanceUpdatedEvent
 */
export type CreditBalanceUpdatedEvent = Message<"lvdr.v2.budget.CreditBalanceUpdatedEvent"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: double delta = 2;
   */
  delta: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.budget.CreditBalanceUpdatedEvent.
 * Use `create(CreditBalanceUpdatedEventSchema)` to create a new message.
 */
export const CreditBalanceUpdatedEventSchema: GenMessage<CreditBalanceUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 2);

/**
 * @generated from message lvdr.v2.budget.CreditsLowWarningEvent
 */
export type CreditsLowWarningEvent = Message<"lvdr.v2.budget.CreditsLowWarningEvent"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: double threshold = 2;
   */
  threshold: number;
};

/**
 * Describes the message lvdr.v2.budget.CreditsLowWarningEvent.
 * Use `create(CreditsLowWarningEventSchema)` to create a new message.
 */
export const CreditsLowWarningEventSchema: GenMessage<CreditsLowWarningEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 3);

/**
 * @generated from message lvdr.v2.budget.CreditsExhaustedEvent
 */
export type CreditsExhaustedEvent = Message<"lvdr.v2.budget.CreditsExhaustedEvent"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: google.protobuf.Timestamp exhausted_at = 2;
   */
  exhaustedAt?: Timestamp | undefined;

  /**
   * @generated from field: double estimated_cost = 3;
   */
  estimatedCost: number;

  /**
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message lvdr.v2.budget.CreditsExhaustedEvent.
 * Use `create(CreditsExhaustedEventSchema)` to create a new message.
 */
export const CreditsExhaustedEventSchema: GenMessage<CreditsExhaustedEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 4);

/**
 * @generated from message lvdr.v2.budget.CreditsRefilledEvent
 */
export type CreditsRefilledEvent = Message<"lvdr.v2.budget.CreditsRefilledEvent"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: double amount = 2;
   */
  amount: number;

  /**
   * @generated from field: google.protobuf.Timestamp refilled_at = 3;
   */
  refilledAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.budget.CreditsRefilledEvent.
 * Use `create(CreditsRefilledEventSchema)` to create a new message.
 */
export const CreditsRefilledEventSchema: GenMessage<CreditsRefilledEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 5);

/**
 * @generated from message lvdr.v2.budget.AutoRefillCheckoutEvent
 */
export type AutoRefillCheckoutEvent = Message<"lvdr.v2.budget.AutoRefillCheckoutEvent"> & {
  /**
   * @generated from field: double balance = 1;
   */
  balance: number;

  /**
   * @generated from field: double threshold = 2;
   */
  threshold: number;

  /**
   * @generated from field: string checkout_url = 3;
   */
  checkoutUrl: string;

  /**
   * @generated from field: string pack = 4;
   */
  pack: string;
};

/**
 * Describes the message lvdr.v2.budget.AutoRefillCheckoutEvent.
 * Use `create(AutoRefillCheckoutEventSchema)` to create a new message.
 */
export const AutoRefillCheckoutEventSchema: GenMessage<AutoRefillCheckoutEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 6);

/**
 * @generated from message lvdr.v2.budget.TierChangedEvent
 */
export type TierChangedEvent = Message<"lvdr.v2.budget.TierChangedEvent"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string new_tier = 2;
   */
  newTier: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.budget.TierChangedEvent.
 * Use `create(TierChangedEventSchema)` to create a new message.
 */
export const TierChangedEventSchema: GenMessage<TierChangedEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 7);

/**
 * @generated from message lvdr.v2.budget.SeatRevokedEvent
 */
export type SeatRevokedEvent = Message<"lvdr.v2.budget.SeatRevokedEvent"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.budget.SeatRevokedEvent.
 * Use `create(SeatRevokedEventSchema)` to create a new message.
 */
export const SeatRevokedEventSchema: GenMessage<SeatRevokedEvent> = /*@__PURE__*/
  messageDesc(file_budget_budget, 8);

/**
 * Per-conversation chat credits (credits-visibility spec). session_id maps to
 * the ledger reference_id "chat:<session_id>" that the gateway billingHook
 * stamps for chat turns. Credits is the ledger-authoritative spend (int64).
 *
 * @generated from message lvdr.v2.budget.GetChatCreditsRequest
 */
export type GetChatCreditsRequest = Message<"lvdr.v2.budget.GetChatCreditsRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.budget.GetChatCreditsRequest.
 * Use `create(GetChatCreditsRequestSchema)` to create a new message.
 */
export const GetChatCreditsRequestSchema: GenMessage<GetChatCreditsRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 9);

/**
 * @generated from message lvdr.v2.budget.GetChatCreditsResponse
 */
export type GetChatCreditsResponse = Message<"lvdr.v2.budget.GetChatCreditsResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int64 credits = 2;
   */
  credits: bigint;
};

/**
 * Describes the message lvdr.v2.budget.GetChatCreditsResponse.
 * Use `create(GetChatCreditsResponseSchema)` to create a new message.
 */
export const GetChatCreditsResponseSchema: GenMessage<GetChatCreditsResponse> = /*@__PURE__*/
  messageDesc(file_budget_budget, 10);

/**
 * Per-surface credit spend for the /usage breakdown (ledger-sourced).
 *
 * @generated from message lvdr.v2.budget.GetCreditsBreakdownRequest
 */
export type GetCreditsBreakdownRequest = Message<"lvdr.v2.budget.GetCreditsBreakdownRequest"> & {
};

/**
 * Describes the message lvdr.v2.budget.GetCreditsBreakdownRequest.
 * Use `create(GetCreditsBreakdownRequestSchema)` to create a new message.
 */
export const GetCreditsBreakdownRequestSchema: GenMessage<GetCreditsBreakdownRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 11);

/**
 * @generated from message lvdr.v2.budget.CreditsBreakdownResponse
 */
export type CreditsBreakdownResponse = Message<"lvdr.v2.budget.CreditsBreakdownResponse"> & {
  /**
   * @generated from field: int64 chat = 1;
   */
  chat: bigint;

  /**
   * @generated from field: int64 voice = 2;
   */
  voice: bigint;

  /**
   * @generated from field: int64 research = 3;
   */
  research: bigint;

  /**
   * @generated from field: int64 other = 4;
   */
  other: bigint;

  /**
   * recordings is ASR transcription spend (reference_id "recording:<id>"),
   * broken out of the former "other" catch-all.
   *
   * @generated from field: int64 recordings = 5;
   */
  recordings: bigint;

  /**
   * documents is docling premium PDF→markdown conversion spend (reference_id
   * "document:<id>"); previously mis-bucketed as research via a bare doc-id.
   *
   * @generated from field: int64 documents = 6;
   */
  documents: bigint;

  /**
   * storage is BILL-11b storage overage spend (reference_id "storage:<user>:<day>").
   *
   * @generated from field: int64 storage = 7;
   */
  storage: bigint;
};

/**
 * Describes the message lvdr.v2.budget.CreditsBreakdownResponse.
 * Use `create(CreditsBreakdownResponseSchema)` to create a new message.
 */
export const CreditsBreakdownResponseSchema: GenMessage<CreditsBreakdownResponse> = /*@__PURE__*/
  messageDesc(file_budget_budget, 12);

/**
 * Per-call voice credits for the active-call bar (credits-visibility spec).
 * session_id maps to the ledger reference_id "voice:<session_id>" — the same tag
 * the gateway billingHook stamps for voice LLM turns AND the EL per-minute
 * close-cost deduction, so Credits is the whole call (EL + LLM). Mirror of
 * GetChatCredits; shares the org-resolution authorization boundary (no org on
 * the wire).
 *
 * @generated from message lvdr.v2.budget.GetVoiceCreditsRequest
 */
export type GetVoiceCreditsRequest = Message<"lvdr.v2.budget.GetVoiceCreditsRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message lvdr.v2.budget.GetVoiceCreditsRequest.
 * Use `create(GetVoiceCreditsRequestSchema)` to create a new message.
 */
export const GetVoiceCreditsRequestSchema: GenMessage<GetVoiceCreditsRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 13);

/**
 * @generated from message lvdr.v2.budget.GetVoiceCreditsResponse
 */
export type GetVoiceCreditsResponse = Message<"lvdr.v2.budget.GetVoiceCreditsResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int64 credits = 2;
   */
  credits: bigint;
};

/**
 * Describes the message lvdr.v2.budget.GetVoiceCreditsResponse.
 * Use `create(GetVoiceCreditsResponseSchema)` to create a new message.
 */
export const GetVoiceCreditsResponseSchema: GenMessage<GetVoiceCreditsResponse> = /*@__PURE__*/
  messageDesc(file_budget_budget, 14);

/**
 * Auto-refill settings (per-org). Requests carry no org_id — the server
 * resolves the org from the authenticated session (the resolution is the auth
 * boundary), mirroring GetCreditBalanceRequest. The write is gated by
 * billing:manage. AutoRefillSettingsResponse is shared by Get + Update and
 * always carries the server-validated, persisted values.
 *
 * @generated from message lvdr.v2.budget.GetAutoRefillSettingsRequest
 */
export type GetAutoRefillSettingsRequest = Message<"lvdr.v2.budget.GetAutoRefillSettingsRequest"> & {
};

/**
 * Describes the message lvdr.v2.budget.GetAutoRefillSettingsRequest.
 * Use `create(GetAutoRefillSettingsRequestSchema)` to create a new message.
 */
export const GetAutoRefillSettingsRequestSchema: GenMessage<GetAutoRefillSettingsRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 15);

/**
 * @generated from message lvdr.v2.budget.UpdateAutoRefillSettingsRequest
 */
export type UpdateAutoRefillSettingsRequest = Message<"lvdr.v2.budget.UpdateAutoRefillSettingsRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: int64 threshold = 2;
   */
  threshold: bigint;

  /**
   * @generated from field: string pack = 3;
   */
  pack: string;
};

/**
 * Describes the message lvdr.v2.budget.UpdateAutoRefillSettingsRequest.
 * Use `create(UpdateAutoRefillSettingsRequestSchema)` to create a new message.
 */
export const UpdateAutoRefillSettingsRequestSchema: GenMessage<UpdateAutoRefillSettingsRequest> = /*@__PURE__*/
  messageDesc(file_budget_budget, 16);

/**
 * @generated from message lvdr.v2.budget.AutoRefillSettingsResponse
 */
export type AutoRefillSettingsResponse = Message<"lvdr.v2.budget.AutoRefillSettingsResponse"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: int64 threshold = 2;
   */
  threshold: bigint;

  /**
   * @generated from field: string pack = 3;
   */
  pack: string;
};

/**
 * Describes the message lvdr.v2.budget.AutoRefillSettingsResponse.
 * Use `create(AutoRefillSettingsResponseSchema)` to create a new message.
 */
export const AutoRefillSettingsResponseSchema: GenMessage<AutoRefillSettingsResponse> = /*@__PURE__*/
  messageDesc(file_budget_budget, 17);

